import { LOCATIONS } from "../../common/location";

const resolveLocationDisplay = (intakeQuestions, patientLocation) => {
    if (intakeQuestions?.location?.trim()) {
        return intakeQuestions.location.trim();
    }
    if (patientLocation) {
        const entry = Object.entries(LOCATIONS).find(([, code]) => code === patientLocation);
        return entry?.[0] || "";
    }
    return "";
};

const formatTelephoneFromIntake = (callerNumber, callerNumberExt) => {
    const number = callerNumber?.trim();
    if (!number) return "";
    const ext = callerNumberExt?.trim();
    return ext ? `${number} ext ${ext}` : number;
};

const setFreeTextByTag = (questionResponse, tag, value) => {
    if (!value?.trim()) return questionResponse;

    return questionResponse.map((question) => {
        if (question.tag !== tag) return question;

        const answer = [...(question.answer || [])];
        if (answer[0]) {
            answer[0] = { ...answer[0], answer: value.trim() };
        }

        return { ...question, answer };
    });
};

const setRadioByTag = (questionResponse, tag, selectedOption) => {
    if (!selectedOption) return questionResponse;

    return questionResponse.map((question) => {
        if (question.tag !== tag) return question;

        return {
            ...question,
            answer: question.answer.map((opt) => ({
                ...opt,
                answer: opt.option === selectedOption,
            })),
        };
    });
};

const setDropDownByTag = (questionResponse, tag, value) => {
    if (!value?.trim()) return questionResponse;

    const trimmed = value.trim();

    return questionResponse.map((question) => {
        if (question.tag !== tag) return question;

        let answer = question.answer.map((opt) => ({
            ...opt,
            answer:
                trimmed === opt.value || trimmed === opt.option || trimmed === opt.name
                    ? trimmed
                    : "",
        }));

        const selected = answer.filter((item) => item.answer === trimmed);
        const rest = answer.filter((item) => item.answer !== trimmed);
        answer = [...selected, ...rest];

        return { ...question, answer };
    });
};

/**
 * Prefills questionnaire template from encounter intakeQuestions (reverse of buildWaitingRoomIntakeQuestions).
 */
export const applyIntakeQuestionsToQuestionResponse = (
    template,
    intakeQuestions,
    { patientLocation } = {}
) => {
    if (!template?.length || !intakeQuestions) {
        return { questionResponse: template || [], didPrefill: false };
    }

    let result = [...template];
    let didPrefill = false;

    if (intakeQuestions.callerName?.trim()) {
        result = setFreeTextByTag(result, "CALLER", intakeQuestions.callerName);
        didPrefill = true;
    }

    const telephone = formatTelephoneFromIntake(
        intakeQuestions.callerNumber,
        intakeQuestions.callerNumberExt
    );
    if (telephone) {
        result = setFreeTextByTag(result, "TELEPHONE", telephone);
        didPrefill = true;
    }

    if (intakeQuestions.intakeReason?.trim()) {
        result = setFreeTextByTag(result, "REASON", intakeQuestions.intakeReason);
        didPrefill = true;
    }

    const relationship = intakeQuestions.callerRelationship?.trim();
    if (relationship === "Self") {
        result = setRadioByTag(result, "SELFCALLING", "Yes");
        didPrefill = true;
    } else if (relationship) {
        result = setRadioByTag(result, "SELFCALLING", "No");
        result = setDropDownByTag(result, "RELATIONSHIP", relationship);
        didPrefill = true;
    }

    const locationDisplay = resolveLocationDisplay(intakeQuestions, patientLocation);
    if (locationDisplay) {
        result = setDropDownByTag(result, "LOCATION", locationDisplay);
        didPrefill = true;
    }

    return { questionResponse: result, didPrefill };
};
